<template>
  <v-container max-width="100%">
    <v-btn color="white" fab small fixed top left @click="openFilterDrawer" style="z-index: 10000; margin-top: 25px;">
      <v-icon color="primary">mdi-filter</v-icon>
    </v-btn>

    <v-navigation-drawer v-model="showingFilterDrawer" absolute overlay-opacity="0" temporary left dark
      style="width: 30%; z-index: 9000">
      <v-card>
        <v-card-title>
          <v-toolbar-title>{{ $t("dashboard.filter") }}</v-toolbar-title>
        </v-card-title>
      </v-card>
      <v-autocomplete :items="unidadesPermitidas" v-model="idUnidadeSelected" item-text="descricao_unidade" item-value="id_unidade"
            prepend-inner-icon="mdi-map-marker" :label="$tc('dashboard.businessUnits', 1)" clearable solo rounded @change="filterChanged"
            style="margin-top: 10px; margin-left: 10px; margin-right: 10px;" hide-details>
      </v-autocomplete>
      <LazySelect ref="linhaSelect" get-url="getLinhaslazy" text="cod_linha" value="id_linha"
            icon="mdi-vector-line" :label="$tc('dashboard.routes', 1)" :extra-data="linhaLazyExtraData" solo rounded
            style="margin-top: 5px; margin-left: 10px; margin-right: 10px;" hide-details @input="onLinhaSelect" />
      <v-autocomplete :items="veiculosFiltrados" v-model="idVeiculoSelected" item-text="numero_ordem" item-value="id_veiculo"
            prepend-inner-icon="mdi-bus" :label="$tc('dashboard.vehicles', 1)" clearable solo rounded @change="filterChanged"
            style="margin-top: 5px; margin-left: 10px; margin-right: 10px;" hide-details>
      </v-autocomplete>
    </v-navigation-drawer>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-card height="80vh">
          <v-card-title color="primary">
            <v-toolbar elevation="0" width="100%">
              <v-toolbar-title color="primary">{{ $t("dashboard.ocupationRate") + filterTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" @click="$router.push({ name: 'RELEmbarques' })"
                    v-on="on">mdi-file-document</v-icon>
                </template>
                <div>{{ $t("nav.communication.reports") }}</div>
              </v-tooltip> -->
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <apexchart width="100%" type="bar" :options="taxaOcupacaoOptions" :series="taxaOcupacaoSeries">
            </apexchart>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-icon color="primary" @click="passarPagina(0)">mdi-chevron-left</v-icon>
            <div>{{ `${pagina} de ${numeroPaginas}` }}</div>
            <v-icon color="primary" @click="passarPagina(1)">mdi-chevron-right</v-icon>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card height="80vh">
          <v-card-title color="primary">
            <v-toolbar elevation="0" width="100%">
              <v-toolbar-title color="primary">{{ $t("dashboard.embarkationsAndBlocks") + filterTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top v-if="podeVerRelEmbarques">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" @click="$router.push({ name: 'RELEmbarques' })"
                    v-on="on">mdi-file-document</v-icon>
                </template>
                <div>{{ $t("nav.communication.reports") }}</div>
              </v-tooltip>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-progress-linear v-if="loadingEventosChart" indeterminate color="primary"></v-progress-linear>
            <apexchart width="100%" type="bar" :options="eventosPorHoraOptions" :series="eventosHoraDiaSeries">
            </apexchart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card height="80vh">
          <v-card-title color="primary">
            <v-toolbar elevation="0" width="100%">
              <v-toolbar-title color="primary">{{ $t("dashboard.trips") + filterTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top v-if="podeVerQuadroViagens">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" @click="$router.push({ name: 'QuadroViagens' })"
                    v-on="on">mdi-chart-gantt</v-icon>
                </template>
                <div>{{ $t("dashboard.quadroViagens") }}</div>
              </v-tooltip>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-data-table 
              :items="viagensFiltradas" 
              :headers="headersViagens"
              :item-class="getViagemStyle"
              item-key="id_viagem_grid"
              @click:row="plot"
            >

            <template v-slot:item.progresso_viagem="{ item }">
              <PercentItem :value="item.progresso_viagem"></PercentItem>
            </template>

            <template v-slot:item.taxa_ocupacao_embarques_validos="{ item }">
              <div>{{ item.taxa_ocupacao_embarques_validos != null ? `${item.taxa_ocupacao_embarques_validos} %` : null }}</div>
            </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import PercentItem from "./PercentItem.vue";
import LazySelect from "./Selects/LazySelect.vue";
import { hasScreenPermission } from "@/utils/postLoginNavigation";
import { isSuperadminUser } from "@/utils/routingModePerfilFilter";

/** Tamanho de cada faixa de horário buscada no servidor (horas). */
const EMBARQUES_JANELA_HORAS = 2;
/** Quantas faixas finais são refeitas a cada polling (as demais já estão em memória). */
const EMBARQUES_JANELAS_POLLING = 2;
/** Os slots do gráfico têm 30 minutos: a faixa seguinte começa um slot depois para não repetir. */
const EMBARQUES_SLOT_MS = 30 * 60 * 1000;
const EMBARQUES_POLLING_MS = 180000;

export default {
  name: "DashboardMain",
  components: {
    PercentItem,
    LazySelect,
  },
  data: () => ({
    search: '',
    user: null,
    token: null,
    permissoes: [],
    fotoPessoa: null,
    eventos: [],
    eventosHora: [],
    eventosHoraDia: [],
    eventosHoraDiaVeiculos: [],
    eventosHoraDiaRotas: [],
    eventosHoraDiaUnidades: [],
    veiculos: [],
    veiculosSelect: [],
    idVeiculoSelected: null,
    /** Item da linha escolhida no select lazy (usado no titulo dos graficos). */
    linhaSelecionada: null,
    viagens: [],
    unidades: [],
    idLinhaSelected: null,
    mostrarAutorizados: true,
    mostrarRecusados: true,
    mostrarRotaErrada: true,
    eventoSelecionado: null,
    eventoMarker: null,
    loadingEventos: false,
    loadingEventosHora: false,
    loadingEmbarques: false,
    /** Identifica a carga em andamento: respostas de cargas antigas são descartadas. */
    embarquesLoadId: 0,
    /** Filtro + dia já carregados; se mudar, as faixas em memória são descartadas. */
    embarquesFiltroCarregado: null,
    /** dti das faixas já buscadas, para não abrir buraco se o polling atrasar. */
    embarquesJanelasCarregadas: [],
    timeout: null,
    tab: 0,
    orderBy: 1,
    orderAsc: false,
    pagina: 1,
    showingFilterDrawer: false,
    idUnidadeSelected: null,
  }),
  watch: {
    '$i18n.locale'() {
      this.initialize();
    },
    idUnidadeSelected() {
      this.idLinhaSelected = null;
      this.idVeiculoSelected = null;
      this.pagina = 1;
    },
    idVeiculoSelected() {
      this.pagina = 1;
    },
    idLinhaSelected() {
      this.pagina = 1;
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.permissoes = this.lePermissoesSessao();
    this.$root.$emit("toogleMenu", true);
    this.$root.$emit("setUserName", this.user.nome_usuario);
    this.$root.$emit("setPerfilUsuario", this.user.perfil_usuario);
    this.$root.$emit("setUser", this.user);
    this.initialize();
  },
  computed: {
    loadingEventosChart() {
      return this.loadingEmbarques;
    },
    /** Atalhos para outras telas só aparecem para quem tem permissão de acessá-las. */
    podeVerRelEmbarques() {
      return this.temPermissaoTela('RELEmbarques');
    },
    podeVerQuadroViagens() {
      return this.temPermissaoTela('QuadroViagens');
    },
    /**
     * As linhas deixaram de ser carregadas por inteiro no cliente (select lazy), entao
     * o escopo das unidades vem do proprio getallunidades, que ja aplica o escopo do usuario.
     */
    unidadesPermitidas() {
      return this.unidades;
    },
    filterTitle() {
      if (this.idVeiculoSelected) {
        return " - " + this.veiculos.find((v) => v.id_veiculo == this.idVeiculoSelected).numero_ordem;
      }

      if (this.idLinhaSelected) {
        return " - " + (this.linhaSelecionada ? this.linhaSelecionada.cod_linha : "");
      }

      if (this.idUnidadeSelected) {
        return " - " + this.unidades.find((u) => u.id_unidade == this.idUnidadeSelected).descricao_unidade;
      }

      return "";
    },
    eventosLabels() {
      return this.eventosHora.map((e) => e.slot_label);
    },
    chartColor() {
      if (!this.mostrarAutorizados && this.mostrarRecusados) {
        return "red";
      }

      if (this.mostrarAutorizados && !this.mostrarRecusados) {
        return "green";
      }

      return "primary";
    },
    chartLabels() {
      let eventos;

      if (this.idVeiculoSelected) {
        eventos = this.eventosHoraDiaVeiculos.filter((e) => e.id_veiculo == this.idVeiculoSelected);
      } else if (this.idLinhaSelected) {
        eventos = this.eventosHoraDiaRotas.filter((e) => e.id_linha == this.idLinhaSelected);
      } else if (this.idUnidadeSelected === -1) {
        eventos = this.eventosHoraDiaUnidades.filter((e) => e.id_unidade == null || e.id_unidade === -1);
      } else if (this.idUnidadeSelected) {
        eventos = this.eventosHoraDiaUnidades.filter((e) => e.id_unidade == this.idUnidadeSelected);
      } else {
        eventos = this.eventosHoraDia;
      }

      return eventos.map((e) => e.slot_label);
    },
    eventosHoraFiltered() {
      if (!this.mostrarAutorizados && this.mostrarRecusados && !this.mostrarRotaErrada) {
        return this.eventosHora.map((e) => e.n_eventos_recusados);
      }

      if (this.mostrarAutorizados && !this.mostrarRecusados && !this.mostrarRotaErrada) {
        return this.eventosHora.map((e) => e.n_eventos_autorizados);
      }

      if (this.mostrarAutorizados && !this.mostrarRecusados && this.mostrarRotaErrada) {
        return this.eventosHora.map((e) => e.n_eventos_autorizados + e.n_eventos_rota_errada);
      }

      if (!this.mostrarAutorizados && !this.mostrarRecusados && this.mostrarRotaErrada) {
        return this.eventosHora.map((e) => e.n_eventos_rota_errada);
      }

      if (!this.mostrarAutorizados && this.mostrarRecusados && this.mostrarRotaErrada) {
        return this.eventosHora.map((e) => e.n_eventos_recusados + e.n_eventos_rota_errada);
      }

      if (!this.mostrarAutorizados && !this.mostrarRecusados && !this.mostrarRotaErrada) {
        return [];
      }

      return this.eventosHora.map((e) => e.n_eventos_totais);
    },
    eventosHoraDiaSeries() {
      let eventos;

      if (this.idVeiculoSelected) {
        eventos = this.eventosHoraDiaVeiculos.filter((e) => e.id_veiculo == this.idVeiculoSelected);
      } else if (this.idLinhaSelected) {
        eventos = this.eventosHoraDiaRotas.filter((e) => e.id_linha == this.idLinhaSelected);
      } else if (this.idUnidadeSelected === -1) {
        eventos = this.eventosHoraDiaUnidades.filter((e) => e.id_unidade == null || e.id_unidade === -1);
      } else if (this.idUnidadeSelected) {
        eventos = this.eventosHoraDiaUnidades.filter((e) => e.id_unidade == this.idUnidadeSelected);
      } else {
        eventos = this.eventosHoraDia;
      }

      return [
        {
          name: this.$t("dashboard.embarkations"),
          data: eventos.map((e) => e.n_eventos_autorizados),
          color: '#0ac404',
        },
        {
          name: this.$t("dashboard.routeError"),
          data: eventos.map((e) => e.n_eventos_rota_errada),
          color: '#ffa500',
          hidden: !this.mostrarRotaErrada,
        },
        {
          name: this.$t("dashboard.denied"),
          data: eventos.map((e) => e.n_eventos_recusados),
          color: '#c40a04',
          hidden: !this.mostrarRecusados,
        }]
    },
    eventosPorHoraOptions() {
      return {
        chart: {
          id: 'eventos-hora-diario',
          type: 'bar',
          stacked: true
        },
        title: {
          text: this.$t("dashboard.eventsInDay")
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tickAmount: 10,
          categories: this.chartLabels
        }
      }
    },
    taxaOcupacaoOptions() {
      return {
        chart: {
          id: 'taxa-ocupacao',
          type: 'bar',
          horizontal: true,
        },
        title: {
          text: this.$t("dashboard.ocupationRateTitle")
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 5,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          tickAmount: 10,
          categories: this.idVeiculoSelected ? [this.veiculosFiltrados.find((v) => v.id_veiculo == this.idVeiculoSelected).cod_veiculo] : this.veiculosFiltrados.map((v) => v.cod_veiculo).slice((this.pagina - 1) * 10, this.pagina * 10),
          labels: {
            formatter: function(val) {
              return val + '%';
            }
          }
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 10,
        }
      }
    },
    taxaOcupacaoSeries() {
      let data = this.veiculos;
      if (this.idVeiculoSelected) {
        data = this.veiculos.filter((v) => v.id_veiculo == this.idVeiculoSelected);
      } else if (this.idLinhaSelected) {
        data = this.veiculos.filter((v) => v.id_linha_guia == this.idLinhaSelected);
      } else if (this.idUnidadeSelected === -1) {
        data = this.veiculos.filter((v) => !v.unidades || v.unidades.length === 0);
      } else if (this.idUnidadeSelected) {
        data = this.veiculos.filter((v) => v.unidades.includes(this.idUnidadeSelected));
      }

      return [
        {
          name: this.$t("dashboard.ocupationRate"),
          data: data.map((v) => v.taxa_ocupacao).slice((this.pagina - 1) * 10, this.pagina * 10),
          color: '#4a4a4a',
        }
      ]
    },
    numeroPaginas() {
      if (this.idVeiculoSelected) {
        return 1;
      }
      return Math.ceil(this.veiculosFiltrados.length / 10) > 0 ? Math.ceil(this.veiculosFiltrados.length / 10) : 1;
    },
    headersViagens() {
      return [
        { text: this.$t("dashboard.headers.route"), value: "nome_linha" },
        { text: this.$t("dashboard.headers.direction"), value: "descricao_sentido" },
        { text: this.$t("dashboard.headers.shift"), value: "descricao_turno" },
        { text: this.$t("dashboard.headers.escalation"), value: "escalonamento" },
        { text: this.$t("dashboard.headers.vehicle"), value: "numero_ordem_veiculo_realizado" },
        { text: this.$t("dashboard.headers.occupancy"), value: "total_embarques_validos" },
        { text: this.$t("dashboard.headers.occupancyRate"), value: "taxa_ocupacao_embarques_validos" },
        { text: this.$t("dashboard.headers.scheduledDeparture"), value: "horario_saida_prevista_extenso" },
        { text: this.$t("dashboard.headers.actualDeparture"), value: "horario_saida_realizada_extenso" },
        { text: this.$t("dashboard.headers.departureDelay"), value: "atraso_saida" },
        { text: this.$t("dashboard.headers.scheduledArrival"), value: "horario_chegada_prevista_extenso" },
        { text: this.$t("dashboard.headers.actualArrival"), value: "horario_chegada_realizada_extenso" },
        { text: this.$t("dashboard.headers.arrivalDelay"), value: "atraso_chegada" },
        { text: this.$t("dashboard.headers.progress"), value: "progresso_viagem" }]
    },
    /**
     * Filtro de unidade repassado ao getlinhaslazy: o endpoint trata id_unidade = -1
     * como "linhas sem unidade", que era o ramo especial do filtro client-side.
     */
    linhaLazyExtraData() {
      if (this.idUnidadeSelected == null || this.idUnidadeSelected === '') {
        return {};
      }
      return { id_unidade: this.idUnidadeSelected };
    },
    veiculosFiltrados() {
      if (this.idLinhaSelected) {
        return this.veiculos.filter((v) => v.id_linha_guia == this.idLinhaSelected);
      }

      if (this.idUnidadeSelected === -1) {
        return this.veiculos.filter((v) => !v.unidades || v.unidades.length === 0);
      }
      if (this.idUnidadeSelected) {
        return this.veiculos.filter((v) => v.unidades.includes(this.idUnidadeSelected));
      }

      return this.veiculos;
    },
    viagensFiltradas() {
      if (this.idVeiculoSelected) {
        return this.viagens.filter((v) => v.id_veiculo_realizado == this.idVeiculoSelected);
      }

      if (this.idLinhaSelected) {
        return this.viagens.filter((v) => v.id_linha == this.idLinhaSelected);
      }

      if (this.idUnidadeSelected === -1) {
        return this.viagens.filter((v) => v.id_unidade == null || v.id_unidade === -1);
      }
      if (this.idUnidadeSelected) {
        return this.viagens.filter((v) => v.id_unidade == this.idUnidadeSelected);
      }

      return this.viagens;
    }
  },
  mounted() {
  },
  beforeDestroy() {
    // Sem isso o polling continua rodando depois de sair da tela.
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.embarquesLoadId += 1;
  },
  methods: {
    lePermissoesSessao() {
      try {
        const raw = sessionStorage.getItem("permissoes");
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    temPermissaoTela(nomeTela) {
      if (isSuperadminUser(this.user)) return true;
      return hasScreenPermission(this.permissoes, nomeTela);
    },
    initialize() {
      this.populaVeiculos();
      this.populaUnidades();
      this.populaDashboard();
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          if (Array.isArray(response.data)) {
            this.veiculos = response.data;
            this.populaVeiculosSelect();
          } else {
            this.veiculos = [];
          }
        },
        onError: () => {
          this.veiculos = [];
        },
      });
    },
    onLinhaSelect(val) {
      this.idLinhaSelected = val != null && val !== '' ? val : null;
      const ref = this.$refs.linhaSelect;
      this.linhaSelecionada =
        this.idLinhaSelected != null && ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(this.idLinhaSelected)
          : null;
      this.filterChanged();
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidades, {
        onSuccess: (response) => {
            const ativas = response.data.filter((u) => u.ativa == 1);
            this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...ativas];
        },
        onError: () => {
          this.unidades = [];
        },
      });
    },
    /**
     * @param {{ somenteUltimasJanelas?: boolean }} [opcoes] — no polling só as últimas
     * faixas de horário são refeitas; as anteriores já estão em memória.
     */
    populaDashboard(opcoes) {
      const somenteUltimasJanelas = !!(opcoes && opcoes.somenteUltimasJanelas);
      this.carregaEventosEmbarques(somenteUltimasJanelas);
      this.populaViagens();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => this.populaDashboard({ somenteUltimasJanelas: true }), EMBARQUES_POLLING_MS);
    },
    onPessoaChanged() {
      if (this.pessoaSelected) {
        this.fotoPessoa = this.pessoaSelected.img_uri;
      } else {
        this.fotoPessoa = null;
      }
    },
    // populaEventos() {
    //   let dti = DateUtils.getDateSQLFormatted(new Date()).substring(0, 10) + "T00:00:00";
    //   let dtf = DateUtils.getDateSQLFormatted(new Date());

    //   axios
    //     .get(ApiBaseUrl + `/api/v1.0/getalleventosdata/${dti}/${dtf}`, {
    //       headers: { "x-access-token": this.token },
    //     })
    //     .then((response) => {
    //       this.loadingEventos = false;
    //       if (!response.data.erro) {
    //         this.eventos = response.data.dados;
    //       }
    //     })
    //     .catch((e) => {
    //       this.loadingEventos = false;
    //       console.log(e);
    //       this.sysError = e;
    //       this.authDialog = true;
    //     });
    // },
    /** Filtro ativo do gráfico de embarques: define endpoint, corpo e destino dos dados. */
    descritorEmbarques() {
      if (this.idVeiculoSelected) {
        return { tipo: "veiculo", id: this.idVeiculoSelected };
      }
      if (this.idLinhaSelected) {
        return { tipo: "rota", id: this.idLinhaSelected };
      }
      if (this.idUnidadeSelected !== null && this.idUnidadeSelected !== undefined) {
        return { tipo: "unidade", id: this.idUnidadeSelected };
      }
      return { tipo: "geral", id: null };
    },
    configEmbarques(descritor, janela) {
      const dti = janela.dti;
      const dtf = janela.dtf;
      if (descritor.tipo === "veiculo") {
        return {
          endpoint: apiController.endpoints.getEmbarquesporhoradataveiculos,
          opcoes: { data: { dti, dtf, idveiculos: [descritor.id] } },
          alvo: "eventosHoraDiaVeiculos",
          campoId: "id_veiculo",
        };
      }
      if (descritor.tipo === "rota") {
        return {
          endpoint: apiController.endpoints.getEmbarquesporhoradatarotas,
          opcoes: { data: { dti, dtf, idlinhas: [descritor.id] } },
          alvo: "eventosHoraDiaRotas",
          campoId: "id_linha",
        };
      }
      if (descritor.tipo === "unidade") {
        return {
          endpoint: apiController.endpoints.getEmbarquesporhoradataunidades,
          opcoes: { data: { dti, dtf, idunidades: descritor.id !== -1 ? [descritor.id] : [] } },
          alvo: "eventosHoraDiaUnidades",
          campoId: "id_unidade",
        };
      }
      return {
        endpoint: apiController.endpoints.getEmbarquesporhoradata,
        opcoes: { params: { dti, dtf } },
        alvo: "eventosHoraDia",
        campoId: null,
      };
    },
    /**
     * Faixas de 30 min do dia operacional divididas em janelas de EMBARQUES_JANELA_HORAS.
     * A janela seguinte começa um slot depois do fim da anterior porque a query devolve
     * o slot inicial e o final — sem isso o slot da fronteira viria duplicado.
     */
    montaJanelasEmbarques() {
      const agora = new Date();
      const inicioDia = new Date(agora);
      inicioDia.setHours(0, 0, 0, 0);

      const passoMs = EMBARQUES_JANELA_HORAS * 60 * 60 * 1000;
      const janelas = [];
      let dti = inicioDia;
      let fimJanela = new Date(inicioDia.getTime() + passoMs);

      while (dti <= agora) {
        const dtf = fimJanela > agora ? agora : fimJanela;
        janelas.push({
          dti: DateUtils.getDateSQLFormatted(dti),
          dtf: DateUtils.getDateSQLFormatted(dtf),
        });
        dti = new Date(fimJanela.getTime() + EMBARQUES_SLOT_MS);
        fimJanela = new Date(fimJanela.getTime() + passoMs);
      }

      return janelas;
    },
    /** Slots já carregados são substituídos pelos novos; o resto é preservado. */
    mesclaEventos(atuais, novos, campoId) {
      const chave = (e) => (campoId ? `${e[campoId]}|${e.slot}` : e.slot);
      const mapa = new Map();
      for (const e of atuais) {
        mapa.set(chave(e), e);
      }
      for (const e of novos) {
        mapa.set(chave(e), e);
      }
      return Array.from(mapa.values()).sort((a, b) => {
        if (campoId && a[campoId] !== b[campoId]) {
          return a[campoId] < b[campoId] ? -1 : 1;
        }
        if (a.slot === b.slot) return 0;
        return a.slot < b.slot ? -1 : 1;
      });
    },
    limpaEventosEmbarques() {
      this.embarquesJanelasCarregadas = [];
      this.eventosHoraDia = [];
      this.eventosHoraDiaVeiculos = [];
      this.eventosHoraDiaRotas = [];
      this.eventosHoraDiaUnidades = [];
    },
    requisitaEventosJanela(config) {
      return new Promise((resolve) => {
        // apiController rejeita a promise em erro; o onError já resolve com [].
        const requisicao = apiController.request(
          config.endpoint,
          Object.assign({}, config.opcoes, {
            silent: true,
            onSuccess: (response) => {
              const dados = response && response.data ? response.data.dados : null;
              resolve(Array.isArray(dados) ? dados : []);
            },
            onError: (e) => {
              console.log(e);
              resolve([]);
            },
          })
        );
        if (requisicao && typeof requisicao.catch === 'function') {
          requisicao.catch(() => {});
        }
      });
    },
    /**
     * Busca os embarques do dia em faixas de horário, aplicando cada uma assim que chega —
     * o gráfico vai se desenhando em vez de esperar uma única resposta gigante.
     * No polling refaz só as últimas faixas, que são as que ainda mudam.
     */
    async carregaEventosEmbarques(somenteUltimasJanelas) {
      const loadId = ++this.embarquesLoadId;
      const descritor = this.descritorEmbarques();
      const hoje = DateUtils.getDateSQLFormatted(new Date()).substring(0, 10);
      const chaveFiltro = `${descritor.tipo}:${descritor.id}@${hoje}`;
      const mesmoFiltro = chaveFiltro === this.embarquesFiltroCarregado;

      let janelas = this.montaJanelasEmbarques();
      if (somenteUltimasJanelas && mesmoFiltro) {
        // As últimas faixas ainda recebem embarques; as anteriores só são refeitas
        // se nunca chegaram (polling atrasado, aba suspensa, erro de rede).
        const carregadas = new Set(this.embarquesJanelasCarregadas);
        const corteUltimas = Math.max(0, janelas.length - EMBARQUES_JANELAS_POLLING);
        janelas = janelas.filter((j, i) => i >= corteUltimas || !carregadas.has(j.dti));
      } else {
        // Filtro (ou dia) diferente: o que está em memória não vale mais.
        this.limpaEventosEmbarques();
      }
      this.embarquesFiltroCarregado = chaveFiltro;

      this.loadingEmbarques = true;
      try {
        for (const janela of janelas) {
          if (loadId !== this.embarquesLoadId) return;
          const config = this.configEmbarques(descritor, janela);
          const dados = await this.requisitaEventosJanela(config);
          if (loadId !== this.embarquesLoadId) return;
          this[config.alvo] = this.mesclaEventos(this[config.alvo], dados, config.campoId);
          if (!this.embarquesJanelasCarregadas.includes(janela.dti)) {
            this.embarquesJanelasCarregadas.push(janela.dti);
          }
        }
      } finally {
        if (loadId === this.embarquesLoadId) {
          this.loadingEmbarques = false;
        }
      }
    },
    populaVeiculosSelect() {
      if (this.idLinhaSelected) {
        this.veiculosSelect = this.veiculos.filter((v) => v.id_linha == this.idLinhaSelected);
      } else {
        this.veiculosSelect = this.veiculos;
      }
    },
    populaViagens() {
      apiController.request(apiController.endpoints.getViagensdashboard, {
        onSuccess: (response) => {
          this.viagens = response.data;
        },
      });
    },
    onRotaChanged() {
      this.populaVeiculosSelect();
    },
    chartOrderChange(order) {
      if (order === this.orderBy) {
        this.orderAsc = !this.orderAsc;
      } else {
        this.orderBy = order;
        this.orderAsc = false;
      }
    },
    passarPagina(tipo) {
      if (tipo === 0) {
        if (this.pagina > 1) {
          this.pagina -= 1;
        }
      } else {
        if (this.pagina < this.numeroPaginas) {
          this.pagina += 1;
        }
      }
    },
    getViagemStyle(item) {
      if (item.horario_saida_realizada_extenso) {
        if (item.horario_chegada_realizada_extenso) {
          return "viagem__realizada__style";
        }

        return "viagem__aberta__style";
      }

      return null;
    },
    plot(item) {
      if (item.id_veiculo_realizado) { 
        this.$router.push({ path: "/relplotagem", query: { 
          idempresa: item.id_empresa, 
          idveiculo: item.id_veiculo_realizado,
          dti: item.horario_saida_prevista,
          dtf: item.horario_chegada_prevista
        }});
      }
    },
    openFilterDrawer() {
      this.showingFilterDrawer = !this.showingFilterDrawer;
    },
    filterChanged() {
      this.populaDashboard();
    }
    //     getIcon() {
    //       let corExterna = "#e74c3c";
    //       let corInterna = "#c0392b";
    //       if (this.eventoSelecionado.autorizado == 1) {
    //         corExterna = "green";
    //         corInterna = "darkgreen";
    //       }

    //       return L.divIcon({
    //           className: 'my-custom-pin',
    //           html: `<svg width="40px" height="40px" viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/">
    //  <g transform="translate(0 -1028.4)">
    //   <path d="m12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z" transform="translate(0 1028.4)" fill="${corExterna}"/>
    //   <path d="m12 3c-2.7614 0-5 2.2386-5 5 0 2.761 2.2386 5 5 5 2.761 0 5-2.239 5-5 0-2.7614-2.239-5-5-5zm0 2c1.657 0 3 1.3431 3 3s-1.343 3-3 3-3-1.3431-3-3 1.343-3 3-3z" transform="translate(0 1028.4)" fill="${corInterna}"/>
    //  </g>
    // </svg>`,
    //         iconAnchor: [20, 40],
    //         popupAnchor: [0, -40]
    //         });
    //     },
  },
};
</script>

<style>
#mapdiv {
  margin-top: 10px;
  height: 23vh;
  width: 100%;
}

</style>